import PropTypes from "prop-types";

export default PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string,
  type: PropTypes.string,
});
